import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CanvasserRedirectDetails } from 'src/app/models/navbar-canvasser-detail';
import { CacheService } from 'src/app/services/cache.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-app-selection',
    templateUrl: './app-selection.component.html',
    styleUrls: ['./app-selection.component.scss'],
    standalone: false
})
export class AppSelectionComponent {
  public redirectUser?: CanvasserRedirectDetails;
  public isProduction: boolean = environment.production;

  constructor(private router: Router, private _cacheService: CacheService) {
    this.redirectUser = _cacheService.getItem('redirectUser');
  }

  redirectFoneyam() {
    if (this.redirectUser && this.redirectUser.navbarUser) {
      this.redirectUser.navbarUser.isDarwin = this._cacheService.getItem('darwinEnabled').foneYamDarwin;
    }
    this.router.navigate(['/app-selection']).then(() => {
      window.location.href =
        `${environment.MDLAPP}/login/?RedirectDetails=` +
        btoa(JSON.stringify(this.redirectUser));
    });
  }

  redirectAplus() {
    if (this.redirectUser && this.redirectUser.navbarUser) {
      this.redirectUser.navbarUser.isDarwin = this._cacheService.getItem('darwinEnabled').aplusDarwin;
    }
    this.router.navigate(['/app-selection']).then(() => {
      window.location.href =
        `${environment.APlusCanvasser}/?aplusCanvasserRedirectDetails=` +
        btoa(JSON.stringify(this.redirectUser));
    });
  }

  redirectLeads() {
    if (this.redirectUser && this.redirectUser.navbarUser) {
      this.redirectUser.navbarUser.isDarwin = this._cacheService.getItem('darwinEnabled').capfinDarwin;
    }
    this.router.navigate(['/app-selection']).then(() => {
      window.location.href =
        `${environment.CapfinLeads}/?capfinLeadsRedirectDetails=` +
        btoa(JSON.stringify(this.redirectUser));
    });
  }

  redirectDocUpload() {
    this.router.navigate(['/app-selection']).then(() => {
      window.open(
        `${environment.DocUpload}/?aplusCanvasserRedirectDetails=` +
        btoa(JSON.stringify(this.redirectUser)),
        '_blank'
      );
    });
  }
  redirectMyPerformance() {
    this.router.navigate(['/app-selection']).then(() => {
      window.location.href =
        `${environment.MyPerformance}/?myPerformanceRedirectDetails=` +
        btoa(JSON.stringify(this.redirectUser));
    });
  }

  get companyName(): string {
    return this.redirectUser?.navbarUser?.company_Name?.trim() ?? '';
  }

}
